import { Grid2 } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../../../assets/logos/admin_logo.svg";
import "../../../DrugAssignmentBatchRelease/DrugAssignment.css";
import { formatDateString } from "../../../../utilities/helper";

const ConfirmAcknowledge = ({ setShowConfirm, data }) => {
  const navigate = useNavigate();

  const fields = [
    { label: "Order Number", key: "orderNumber" },
    { label: "Source of Order", key: "orderSource" },
    { label: "Destination of Order", key: "orderDestination" },
    { label: "Order Type", key: "orderType" },
    { label: "Site Investigator Name", key: "investigator" },
    { label: "Date Order was Raised", key: "orderDate" },
    { label: "Order Status", key: "orderStatus" },
    { label: "Date Order was Acknowledged", key: "orderAcknowledgedDate" },
    { label: "Kit(s) Moved Back to Quarantine", key: "orderKitsinQuarantine" },
    { label: "Kit Number(s) Damaged", key: "orderKitsDamaged" },
    { label: "Kit Number(s) Missing", key: "orderKitsMissing" },
    {
      label: "Kit Number(s) Received in Good Condition",
      key: "orderKitsinGoodCondition",
    },
  ];

  const email = localStorage.getItem("email");

  return (
    <div className="content-body">
      <p className="bread-crumbs-link-container" style={{ fontWeight: "600" }}>
        <Link className="bread-crumbs-link" to="/">
          Home
        </Link>{" "}
        |{" "}
        <Link
          className="bread-crumbs-link"
          to="/drug-shipment-management"
          onClick={() => setShowConfirm(false)}
        >
          Drug Order Management
        </Link>
        |{" "}
        <Link className="bread-crumbs-link">
          Drug Order Acknowledged Confirmation
        </Link>
        -{" "}
        <b style={{ color: "gray" }}>{localStorage?.getItem("studyName")}</b>
      </p>
      <Grid2
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{ width: "100%", margin: "0 auto" }}
      >
        <Grid2 item md={6}>
          <p className="page-heading">
            Genesis StudyPortal Confirmation of Drug Order Acknowledgement
          </p>
        </Grid2>
      </Grid2>
      <div className="heading-container">
        <h4>Confirmation of Order Acknowledgement Genesis StudyPortal</h4>
      </div>
      <div className="inner-heading-container">
        <img className="admin-logo logo-image" src={logo} alt="Genesis Logo" />
        <div className="data-block">
          <div className="data-inner-block">
            <span
              className="data-inner-block-text"
              style={{
                display: "block",
                width: "210px",
                textAlign: "right",
              }}
            >
              User Name :{" "}
            </span>
            <span
              style={{
                color: "white",
                textAlign: "left",
              }}
            >
              {" "}
              {email}
            </span>
          </div>

          <div className="data-inner-block">
            <span
              className="data-inner-block-text"
              style={{
                display: "block",
                width: "210px",
                textAlign: "right",
              }}
            >
              System Transaction Date :
            </span>
            <span
              style={{
                color: "white",
                textAlign: "left",
              }}
            >
              {" "}
              {new Date().toLocaleDateString()}
            </span>
          </div>

          <div className="data-inner-block">
            <span
              className="data-inner-block-text"
              style={{
                display: "block",
                width: "210px",
                textAlign: "right",
              }}
            >
              Site Transaction Date :
            </span>
            <span
              style={{
                color: "white",
                textAlign: "left",
              }}
            >
              {" "}
              {new Date().toLocaleDateString()}
            </span>
          </div>
        </div>
      </div>
      <div className="data-content-container">
        {fields.map(({ label, key }) => (
          <div className="data-content" key={key}>
            <span
              className="data-content-label"
              style={{
                width: "25.5vw",
              }}
            >
              {label} :
            </span>
            <span
              className="data-content-value"
              style={{
                width: "277px",
              }}
            >
              {label == "Date" ? formatDateString(data?.[key]) : data?.[key]}
              {/* USA LABEL */}
            </span>
          </div>
        ))}
      </div>

      <div className="note-container">
        <span
          style={{
            fontWeight: "600",
            color: "#585858",
          }}
        >
          Note :
        </span>
        <span>
          This order has been acknowledged successfully. Kits have been updated
          as noted above.{" "}
        </span>
      </div>
      <div
        style={{
          height: "20px",
        }}
      ></div>
      <div className="footer-container">
        <span>
          Genesis 2025-Please contact Genesis Support for assistance at
          Genesis.com/support
        </span>
      </div>
      <div
        style={{
          textAlign: "left",
          margin: "10px",
          fontSize: "10px",
        }}
      >
        You will receive an email confirmation of this transaction.
      </div>
      <Grid2
        alignItems={"center"}
        justifyContent="center"
        container
        gap={3}
        sx={{ marginTop: "2%" }}
      >
        <Grid2 item md={6}>
          <button
            className="create-btn"
            onClick={() => {
              navigate("/");
            }}
          >
            Home
          </button>
        </Grid2>
      </Grid2>
    </div>
  );
};

export default ConfirmAcknowledge;
